
/**
 * File: qpSummary.js
 * Project: educore
 * Created Date: 2018-12-13
 * Author: Raziya S
 * Screen : 
 */
class answersheetPreview {
    // @ngInject
    constructor($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, SchoolLogo, CONSTANTS, $sce ) {

        let authoring = localStorageService.get("authoringData")
        let qpId = $state.params.qpId
        let studentId = localStorageService.get('user_id')
        let schoolId = authoring.school_id
        $scope.continue = false
        $scope.no_fee_status = false
        var self = this
        let vm = this;
        // $scope.isLoading = true
        vm.reportCardArray = undefined;
        vm.buckets = undefined;
        $scope.reportCardArray = undefined
        this.$onInit = function() {
            if (authoring) {
                init()
            }
        };
        $scope.checkingChoiceExistsPreview = function (choice, data) {
            let isChecked = false;
            if (data.my_answer != undefined) {
                return data.my_answer.indexOf(choice) > -1
            } else {
                return isChecked
            }
        }
        $scope.gotoQpPreview = function () {
            $state.go('qpSummary', {
                qpId: qpId
            })
        }
        $scope.setFilePathPreview = function (img) {
            let new_url = img ? CONSTANTS.FILE_UPLOAD_URL + img : undefined
            return new_url
        }

        $scope.beautifyFIBPreview = function (question) {
            return question.toString().replace(/_/g, " _______ ")
        }
        let MQ = MathQuill.getInterface(2);
        $scope.loadLatexPreview = function () {
            let questionElements = document.getElementsByClassName('question_desc')
            _.each(questionElements, function (spanElement) {
                MQ.StaticMath(spanElement);
            })
        }
        $scope.conertToHtml = function (string) {
            // string = "<span style='color: #89a000'>123</span>"
            return $sce.trustAsHtml(string);

        }
        function init() {
            $scope.isLoadingPreview = true
            let studentId = localStorageService.get('user_id')
            authService.callAPI(activityCons.API_GET_STUDENT_ANSWER_DETAILS + qpId + '/' + studentId, "GET", {}, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        let result = response.result.data.details;
                        if (result && result.comment) {
                            $scope.comment = result.comment
                        }
                        let useFullScreen = ($mdMedia('sm') || $mdMedia('xs'));
                        $scope.my_score = 0
                        $scope.totalmark = 0
                        $scope.quesCount = 0
                        let myScore = 0
                        $scope.isTeacherEvaluation = false
                        _.each(result.consolidatedData, function (sec) {
                            delete sec.questions
                            _.each(sec.answers, function (ans) {
                                if (ans.type === "SA" || ans.type === "LA" || ans.type == "ASLLISTEN" || ans.type == "ASLSPEAK" || ans.type == "DRAW") {
                                    $scope.quesCount++;
                                }
                                $scope.totalmark = ans.total_mark
                                if (!isNaN(ans.my_score)) {
                                    myScore = parseFloat(myScore) + parseFloat(ans.my_score)
                                    myScore = myScore.toFixed(2)
                                    $scope.my_score = myScore
                                }
                            })
                        })
                        $scope.qpDetails = {
                            question_paper_title: result.question_paper_title,
                            subject: authoring.subject,
                            class: authoring.class,
                            time: result.time,
                            due_date: result.due_date
                        }
                        $scope.questionsPreview = result.consolidatedData;
                        setNUmberingAndDeleteSections()
                        $scope.isLoadingPreview = false
                        setTimeout(() => {
                            $scope.loadLatexPreview()
                        }, 100);
                        setChoice();
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            })
        }
        let answFailureArr = localStorageService.get("failureQuestIds");
        if(!answFailureArr || !answFailureArr.length){
            answFailureArr = []
        }
        answFailureArr = _.uniq(answFailureArr)
        function setSavedOrNot(one_question){
            if(one_question){
                let ex = _.find(answFailureArr, function(one){
                    return one == one_question._id 
                })
                if(ex){
                    if(!one_question.is_attended){
                        one_question.attendedStatus = "Not saved"
                    } 
                    else {
                        one_question.attendedStatus = "Not saved!";
                    }
                } else {
                    if(one_question.attendedStatus == "Not attended"){
                        one_question.attendedStatus = "Not Answered";
                    } else if(one_question.attendedStatus == "Attended"){
                        one_question.attendedStatus = "Answered";
                    }
                }

            }
        }
        $scope.array = []
        function setNUmberingAndDeleteSections(){
            let sections = $scope.questionsPreview
            let array = []
            for(let s = 0; s < sections.length; s++){
                for(let a = 0; a < sections[s].answers.length; a++){
                    setSavedOrNot(sections[s].answers[a])
                    array.push(sections[s].answers[a])
                }
            }
            $scope.array = array
        }
        function removeSpecialCharacterPreview(value) {
            if (value) {
                value = value.replace(/\\quad/g, "")
                value = value.replace(/\\/g, "")
            }
            return value
        }
        function setChoice() {
            _.each($scope.questionsPreview, function (section) {
                _.each(section.answers, function (data, key) {
                    $scope.total_mark += parseFloat(data.mark)
                    let score = parseFloat(data.my_score)
                    $scope.score += score;
                    if (data.type == 'MCQ' || data.type == "IBT_MCQ") {
                    } else if (data.type == 'TF') {
                        
                    } else if (data.type == 'FIB' || data.type == "IBT_FIB") {
                        let key = 0
                        let whole_answer_correct = false
                        _.each(data.answer, function (choice) {
                            if (data.my_answer != undefined && data.my_answer[key] != undefined) {
                            } else {
                                if (data.my_answer != undefined) {
                                    data.my_answer[key] = 'Not Answered'
                                } else {
                                    data.my_answer = []
                                    data.my_answer[key] = 'Not Answered'
                                }
                            }
                            key++
                        })
                    } else if (data.type == 'OWQ') {
                        let key = 0
                        let whole_answer_correct = false
                        if (Number(data.my_score) > 0) {
                            whole_answer_correct = true
                        }
                        _.each(data.answer, function (choice) {
                            if (data.my_answer != undefined && data.my_answer[key] != undefined) {
                                
                            } else {
                                if (data.my_answer != undefined) {
                                    data.my_answer[key] = 'Not Answered'
                                } else {
                                    data.my_answer = []
                                    data.my_answer[key] = 'Not Answered'
                                }
                            }
                            key++
                        })
                    } else if (data.type == 'MTF') {
                        data.ans_key = []
                        let key = 0
                        _.each(data.option, function (choice) {
                            let needed = true
                            if (!choice.question.desc) {
                                choice['no_question'] = true
                                needed = false
                            }
                            if (data.my_answer != undefined && data.my_answer[key] != undefined) {
                                let correct = false
                                data.ans_key.push({
                                    desc: data.my_answer[key].desc,
                                    correct: correct,
                                    optImage: data.my_answer[key].optImage,
                                    needed: needed
                                })
                            }
                            key++
                        })
                    } else if (data.type == 'ASLLISTEN') {
                        _.each(data.questions, function (aslListQues) {
                            if (aslListQues.type == 'mcq') {
                                _.each(aslListQues.choice, function (choice) {
                                    if ($scope.checkingChoiceExistsPreview(choice.desc, aslListQues)) {
                                        
                                    }
                                })
                            } else if (aslListQues.type == 'tf') {
                                _.each(aslListQues.choice, function (choice) {
                                    if (aslListQues.my_answer != undefined && choice.tag === aslListQues.my_answer) {
                                        
                                    }
                                })
                            } else if (aslListQues.type == 'fib') {
                                _.each(aslListQues.answer, function (choice, index) {
                                    let correctAnswer = removeSpecialCharacterPreview(choice.desc)
                                    if (aslListQues.my_answer != undefined && aslListQues.my_answer[index] != undefined) {
                                        let studentAnswer = removeSpecialCharacterPreview(aslListQues.my_answer[index])
                                        if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                            // choice.wrong = true
                                        } else {
                                            // choice.correct = true
                                        }
                                    } else {
                                        // choice.wrong = true
                                        if (aslListQues.my_answer != undefined) {
                                            aslListQues.my_answer[index] = 'Not Answered'
                                        } else {
                                            aslListQues.my_answer = []
                                            aslListQues.my_answer[index] = 'Not Answered'
                                        }
                                    }
                                })
                            } else if (aslListQues.type == 'text') {
                                let correctAnswer = removeSpecialCharacterPreview(aslListQues.answer)
                                if (aslListQues.my_answer != undefined) {
                                    let studentAnswer = removeSpecialCharacterPreview(aslListQues.my_answer)
                                    if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                        // aslListQues.wrong = true
                                    } else {
                                        // aslListQues.correct = true
                                    }
                                } else {
                                    // aslListQues.wrong = true
                                    aslListQues.my_answer = 'Not Answered'
                                }
                            }
                        })
                    }
                })
            })
        }
        $scope.clearPreview = () => {
            $scope.questionsPreview = []
        }
        $scope.clickQuestion = (index) => {
            try{
                if($scope.$parent && $scope.$parent.$parent){
                    $scope.$parent.$parent.changeQuestion(index, true)
                }
            }catch(e){
                console.log(e)
            }
            
        }
    }
}
export default answersheetPreview



// WEBPACK FOOTER //
// ./src/app/traditionalActivity/controllers/answersheetPreview.js